module.exports = __webpack_public_path__ + "static/media/easy_upload.113774fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/easy_upload.svg
// module id = 385
// module chunks = 0